import type { Abi } from "viem";

export const erc20Abi = [
  { type: "function", name: "approve", stateMutability: "nonpayable", inputs: [{ name: "spender", type: "address" }, { name: "amount", type: "uint256" }], outputs: [{ name: "", type: "bool" }] },
  { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ name: "account", type: "address" }], outputs: [{ name: "", type: "uint256" }] },
  { type: "function", name: "faucet", stateMutability: "nonpayable", inputs: [], outputs: [] }
] as const satisfies Abi;

export const fpmmAbi = [
  { type: "function", name: "buy", stateMutability: "nonpayable", inputs: [{ name: "investmentAmount", type: "uint256" }, { name: "outcomeIndex", type: "uint256" }, { name: "minOutcomeTokensToBuy", type: "uint256" }], outputs: [] },
  { type: "function", name: "sell", stateMutability: "nonpayable", inputs: [{ name: "returnAmount", type: "uint256" }, { name: "outcomeIndex", type: "uint256" }, { name: "maxOutcomeTokensToSell", type: "uint256" }], outputs: [] },
  { type: "function", name: "addFunding", stateMutability: "nonpayable", inputs: [{ name: "addedFunds", type: "uint256" }, { name: "distributionHint", type: "uint256[]" }], outputs: [] },
  { type: "function", name: "removeFunding", stateMutability: "nonpayable", inputs: [{ name: "sharesToBurn", type: "uint256" }], outputs: [] },
  { type: "function", name: "withdrawFees", stateMutability: "nonpayable", inputs: [{ name: "account", type: "address" }], outputs: [] },
  { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ name: "account", type: "address" }], outputs: [{ name: "", type: "uint256" }] },
  { type: "function", name: "feesWithdrawableBy", stateMutability: "view", inputs: [{ name: "account", type: "address" }], outputs: [{ name: "", type: "uint256" }] }
] as const satisfies Abi;

export const conditionalTokensAbi = [
  { type: "function", name: "setApprovalForAll", stateMutability: "nonpayable", inputs: [{ name: "operator", type: "address" }, { name: "approved", type: "bool" }], outputs: [] },
  { type: "function", name: "balanceOf", stateMutability: "view", inputs: [{ name: "account", type: "address" }, { name: "id", type: "uint256" }], outputs: [{ name: "", type: "uint256" }] },
  { type: "function", name: "redeemPositions", stateMutability: "nonpayable", inputs: [{ name: "collateralToken", type: "address" }, { name: "parentCollectionId", type: "bytes32" }, { name: "conditionId", type: "bytes32" }, { name: "indexSets", type: "uint256[]" }], outputs: [] }
] as const satisfies Abi;

export const positionLensAbi = [
  { type: "function", name: "positionId", stateMutability: "view", inputs: [{ name: "collateralToken", type: "address" }, { name: "parentCollectionId", type: "bytes32" }, { name: "conditionId", type: "bytes32" }, { name: "indexSet", type: "uint256" }], outputs: [{ name: "", type: "uint256" }] }
] as const satisfies Abi;

export const marketFactoryAbi = [
  {
    type: "function",
    name: "createMarket",
    stateMutability: "nonpayable",
    inputs: [{
      name: "params",
      type: "tuple",
      components: [
        { name: "marketKey", type: "bytes32" },
        { name: "metric", type: "uint8" },
        { name: "lowerBound", type: "int256" },
        { name: "upperBound", type: "int256" },
        { name: "resolutionTime", type: "uint64" },
        { name: "reportDeadline", type: "uint64" },
        { name: "fee", type: "uint256" },
        { name: "initialLiquidity", type: "uint256" },
        { name: "distributionHint", type: "uint256[]" },
        { name: "descriptorHash", type: "bytes32" },
        { name: "metadataURI", type: "string" }
      ]
    }],
    outputs: [{ name: "marketId", type: "uint256" }, { name: "questionId", type: "bytes32" }, { name: "fpmm", type: "address" }]
  }
] as const satisfies Abi;
